import { addPromotionBackend } from "../../api";
import {
  checkMinBasketPrice,
  isStringNotNull,
  renderErrorMessage,
} from "../../utils";
import store from "../../redux/store";
import { LOYALTY, LOYALTY_TYPE } from "../../constants";
import { analyticsEvents } from "../../utils/firebaseAnalytics";
import { logMediumError, logMediumLog } from "../../utils/logger";
import { openMessageModal } from "../../utils/common";

export const addLoyalty = async (
  component,
  loyalty,
  totalPriceOrder,
  loyaltyShop
) => {
  const { user } = store.getState().userReducer;
  const { customerId, points } = user;
  try {
    const minBasketPrice = checkMinBasketPrice(loyalty, totalPriceOrder);
    component.setState({ loadingPromotion: true });
    if (loyaltyShop.disabled)
      openMessageModal(
        `Ce restaurant n'est pas éligible au programme de fidélité. Vous pouvez utiliser votre code promotionnel dans un autre point de vente du réseau.`
      )
    else {
      component.setState({ loadingPromotion: true });
      if (isStringNotNull(loyalty)) {
        logMediumLog(`Adding loyalty ${loyalty}`);
        const deviceId = customerId;
        analyticsEvents.logLoyaltyUsed(points);
        await addPromotionBackend(customerId, loyalty, deviceId);
        if (loyalty === LOYALTY)
          openMessageModal(
            `Vos points de fidélité ont été utilisés. ${minBasketPrice
              ? `Pour profiter de votre coupon de fidélité, votre panier doit être supérieur à ${minBasketPrice}€`
              : ""
            }`
          )
        component.setState({ loadingPromotion: false });
      }
    }
  } catch (error) {
    openMessageModal(renderErrorMessage(error));
    component.setState({ loadingPromotion: false });
    logMediumError(`Error adding loyalty ${error}`, { customerId, points });
  }
};

export const getLoyaltyCashback = (companyLoyaltyConfig) =>
  !companyLoyaltyConfig?.enabled ||
    companyLoyaltyConfig?.type !== LOYALTY_TYPE.CASHBACK
    ? null
    : companyLoyaltyConfig?.cashbackConfig;

export const getLoyaltyPercentage = (points, loyalty) => {
  let percentage = Math.round((points / loyalty.limit) * 100);
  if (percentage > 100) {
    percentage = 100;
  }
  return percentage;
};
